import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import "css/generalSettings.css";
import { warningErrorAction } from "actions/ErrorActions";
import ReportPurchseDelivery from 'pages/purchases/generatePDF/ReportPurchaseDelivery'; 
import { helpHttp } from "service/HelpHttp";
import PropTypes from 'prop-types';

const initialStatePurchaseDelivery = {
  id : "",
  defaultStore_id:0, 
  tradename: "",
  useraccount_id:0,
  username: "",
  substore_id:0, 
  substore_name: "",
  purchasenote:0,  
  ownnumberpurchase:"", 
  datepurchase: null, 
  opt_tras_store_id : 0,
  opt_tras_documnettype_id : 1,
  opt_tras_documentid : "",
  opt_tras_tradename : "",
  opt_tras_roadtype_id :  74,
  opt_tras_street : "",
  opt_tras_country_id:  1,
  opt_tras_country_name: "",
  opt_tras_province_id: 30,
  opt_tras_province_name: "",
  opt_tras_postalcode_id: 6911,
  opt_tras_postalcode_code:"",
  opt_tras_postalcode_name: "",
  opt_tras_community_id:  6, 
  opt_tras_community_name: "", 
  opt_tras_email:"",
  opt_tras_licenseplate:"",
  vehiclestore_frame:"", 
  vehicle_marca:"", 
  vehicle_model:"", 
  observations: "",
  totalpurchasedelivery: 0,
  totaldiscountpurchasedelivery: 0,
  totaltaxespurchasedelivery:0,
  totalNetoPurchasedelivery:0,  
  payment_id : 1 ,
  payment_code: "",
  payment_namees: "",
  payment_nameen: "",
  linespurchasedelivery:[]
};
 
const PurchaseDeliveryPDF = ({ id,rowEditPurchaseDelivery, viewPDF, setViewPDF,typeOfList }) => {
  const { t, i18n } = useTranslation(['listDataPurchases']);
  const token = useSelector((state) => state.loginUser.token);
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi.formatnumber);  
  const [dataPurchaseDelivery, setDataPurchaseDelivery] = useState(initialStatePurchaseDelivery);
  const dispatch = useDispatch();
  
  useEffect(() => {
    let isMounted = true;
    const fetchDataTickets = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `purchasedelivery/getpurchasedeliverypdfbyid/`, token, rowEditPurchaseDelivery.id);
        if (getData.err) {
          setDataPurchaseDelivery(initialStatePurchaseDelivery);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailed' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataPurchaseDelivery(getData);
          
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
    if (
      rowEditPurchaseDelivery?.id &&
      defaulttypesdi
    ) {
      fetchDataTickets();
    }

    return () => {isMounted = false;};
  }, [defaulttypesdi, rowEditPurchaseDelivery,  dispatch, t, token,i18n.language]);  
 
  return (
    <div id="pdf-content" style={{ padding: 10 }}>
      {(viewPDF && dataPurchaseDelivery.id!==undefined  && dataPurchaseDelivery.id!==null  && dataPurchaseDelivery.id!=="" && dataPurchaseDelivery.id!=="0" && dataPurchaseDelivery.id!==0 
                && defaulttypesdi!==undefined  &&defaulttypesdi!==null  &&defaulttypesdi!=="" && defaulttypesdi!=="0" && defaulttypesdi!==0
      ) &&  <ReportPurchseDelivery dataPurchaseDelivery={dataPurchaseDelivery}  initialStatePurchaseDelivery={initialStatePurchaseDelivery} setDataPurchaseDelivery={setDataPurchaseDelivery} setViewPDF={setViewPDF} typeOfList={typeOfList}/> }
    </div>
  );
};


PurchaseDeliveryPDF.propTypes = {
  rowEditPurchaseDelivery: PropTypes.object.isRequired,
  viewPDF: PropTypes.bool.isRequired,
  setViewPDF: PropTypes.func.isRequired
};

export default PurchaseDeliveryPDF;
